import { Box } from '@material-ui/core';
import { formatMoney } from '@nemuru-eng/js-api-client';

import { SinglePaymentProviderLogo } from '@/components/modules/Application/components/PaymentMethod/_shared/components/SinglePaymentProviderLogo';
import { AbstractSinglePaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractSinglePaymentMethod';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { IconWithCircle } from '@/components/shared/components/IconWithCircle';
import { IconByAllowedPaymentMethodType } from '@/components/shared/components/PricingsTable/constants/IconByAllowedPaymentMethodType';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface SinglePaymentMethodSummaryCardProps {
  paymentMethodEntity: AbstractSinglePaymentMethod;
  available?: boolean;
}

export const SinglePaymentMethodSummaryCard = ({
  paymentMethodEntity,
  available,
}: SinglePaymentMethodSummaryCardProps) => {
  const { palette } = useCustomTheme();
  const { getTextIdTranslation } = useTranslation();

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems={'center'} gridGap={16} py={1} width={'100%'}>
        <Box display={'flex'} alignItems={'center'} gridGap={16}>
          <Icon size={20} color={available === false ? palette.error.main : palette.secondary.main}>
            {IconByAllowedPaymentMethodType(paymentMethodEntity.paymentMethodType)}
          </Icon>
          <Box display={'flex'} flexDirection={'column'}>
            <Box display={'flex'} flexDirection={'row'} gridGap={4} alignItems={'baseline'}>
              <Font variant={'caption'} color={available === false ? 'error' : 'textPrimary'}>
                {getTextIdTranslation(`${paymentMethodEntity.paymentMethodType}_SHORT`)}{' '}
              </Font>
              {/* {paymentMethodEntity instanceof CardPaymentMethod && <CardPaymentProviderLogos />}{' '} */}
            </Box>

            <Font variant={'body2'} color={available === false ? 'error' : 'textPrimary'}>
              <strong>
                {paymentMethodEntity.amount
                  ? formatMoney({ value: paymentMethodEntity.amount, currency: paymentMethodEntity.currency })
                  : '-'}
              </strong>
            </Font>
          </Box>
        </Box>
        {available === true && <IconWithCircle color={palette.success.main}>check</IconWithCircle>}
        {available === false && <IconWithCircle color={palette.error.main}>error</IconWithCircle>}
        {available === undefined && (
          <SinglePaymentProviderLogo providers={paymentMethodEntity.getAllProviderNames()} size={64} />
        )}
      </Box>
    </>
  );
};
